import { createAction, props } from '@ngrx/store';

export const UpdateExtensionInstallState = createAction('[Extension] Update State ', props<{ isExtensionInstalled: boolean }>());
